module.exports = "<ng-content></ng-content>\n<button mat-icon-button (click)=\"toggleScreen()\" class=\"fill-screen-button\">\n    <mat-icon *ngIf=\"!isEnlarged\" aria-label=\"Enlarge graph\">fullscreen</mat-icon>\n    <mat-icon *ngIf=\"isEnlarged\" aria-label=\"Enlarge graph\">fullscreen_exit</mat-icon>\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/chart/linechart/data.graph.component.html
// module id = 1064
// module chunks = 0